import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const DatabaseIntro = () => {
  const { t } = useTranslation();

  return (
    <section>
      <div className="database-intro">
        <div className="inner">
          <div className="content">
            <div className="intro-warp">
              <div className="intro-img">
                <img
                  src="//files.authing.co/authing-website/product-database-intro-img.png"
                  alt="authing database intro"
                />
              </div>
              <div className="intro-description">
                <div className="">{t("learn.database.intro.description")}</div>
              </div>
            </div>
            <Title title={t("learn.database.sence.title")}>{t("learn.database.sence.subtitle")}</Title>
            <div className="sence-warp">
              <div className="item">
                <div className="icon">
                  <i className="icon authing-icon authing-xuanzhong icon-style"></i>
                </div>
                <div className="name">{t("learn.database.sence.item1.title")}</div>
                <div className="subtitle">{t("learn.database.sence.item1.subtitle")}</div>
              </div>
              <div className="item">
                <div className="icon">
                  <i className="icon authing-icon authing-tedian5 icon-style"></i>
                </div>
                <div className="name">{t("learn.database.sence.item2.title")}</div>
                <div className="subtitle">{t("learn.database.sence.item2.subtitle")}</div>
              </div>
              <div className="item">
                <div className="icon">
                  <i className="icon authing-icon authing-yonghuqianyi icon-style"></i>
                </div>
                <div className="name">{t("learn.database.sence.item3.title")}</div>
                <div className="subtitle">{t("learn.database.sence.item3.subtitle")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
